// import config from 'react-global-configuration';
import Send from './AppEvent'
import { userAgentIsMobile } from "./Auth0MobileUtils";

const RedirectToLoginHomeMicuenta = function () {
    if (Send('LOGIN', "")) return;
    RedirectToLogin(process.env.REACT_APP_MICUENTA);
}

const RedirectToLoginPreserveCallback = () => {
    if (Send('LOGIN', "")) return;
    RedirectToLogin(location.href);
}

const RedirectToLoginDni = (callback, history) => {
    if (!userAgentIsMobile())
        RedirectToLogin(callback);

   history.go(-1);
}

const RedirectToLogin = (callback) => {
    location.href = `${process.env.REACT_APP_LOGIN}auth0-login/D/9/?callback=${window.btoa(callback)}`;
}

const ObtenerLinkActivarSuscripcion = () => {
    return `${process.env.REACT_APP_SUSCRIPCIONES}suscripcion/A/1/?callback=${window.btoa(location.href)}&fc=176&productCategory=Voluntario`
}

export default {
    RedirectToLoginHomeMicuenta,
    RedirectToLoginPreserveCallback,
    ObtenerLinkActivarSuscripcion,
    RedirectToLogin,
    RedirectToLoginDni
}